/* eslint-disable */
import React from 'react';
import { RadioGroup, RadioGroupProps } from '@mui/material';

type Props = {
  children?: React.ReactNode;
};

export function CustomRadioGroup({
  onChange,
  defaultValue,
  children,
}: Props & RadioGroupProps) {
  return (
    <RadioGroup
      defaultValue={defaultValue}
      name="radio-buttons-group"
      onChange={onChange}
    >
      {children}
    </RadioGroup>
  );
}
